import { Injectable } from "@angular/core";
import { environment } from 'environments/environment';

@Injectable()
export class ImageService {

    _companyId: string;
    _themeColor: string;
    _backgroundColor: string;
    _appName: string;
    _successMsg: string;

    get companyId() {
        this._companyId = localStorage.getItem("companyId") ?? "0";
        return this._companyId;
    }

    get themeColor() {
        this._themeColor = localStorage.getItem("themeColor") ?? "#A60000";
        return this._themeColor;
    }

    get backgroundColor() {
        this._backgroundColor = localStorage.getItem("backgroundColor") ?? "lightgray";
        return this._backgroundColor;
    }

    get appName() {
        this._appName = localStorage.getItem("appName") ?? "SOS WebApp";
        return this._appName;
    }

    get successMessage() {
        this._successMsg = localStorage.getItem("successMsg") ?? "Éxito";
        return this._successMsg;
    }

    getImage(imgName: string) {
        return `${environment.ImgSources}/${this.companyId}/${imgName}`;
    }

    onImgError(imgName, event) {
        let src = `${environment.ImgSources}/0/${imgName}`;
        if (event.target.src != src)
            event.target.src = src; //this is to prevent infinite loops on bad url img
    }
}
